import { IFreezeTablesSearchParams } from "../../Interfaces/freeze";
import DynamicMultiSelectDropdown from "../../Components/Dropdown/DynamicMultiSelectDropdown";
import { getStepInstruments } from "../../Requests/stepRequests";
import UsersMultiSelectDropdown from "../../Components/Dropdown/Users/UsersMultiSelectDropdown";

interface IProps {
  searchParam: IFreezeTablesSearchParams;
  onChange: (name: string, value: any) => void;
}

const SearchParamUI = ({ searchParam, onChange }: IProps) => {
  return (
    <div className="flex flex-row justify-start items-center gap-5">
      <div className="w-48">
        <DynamicMultiSelectDropdown
          dropdown={{
            name: "insCodes",
            placeholder: "نماد",
          }}
          onChange={onChange}
          getData={getStepInstruments}
          value={searchParam.insCodes}
        />
      </div>
      <div className="w-48">
        <UsersMultiSelectDropdown
          label="فیلتر اکانت"
          name="accounts"
          value={searchParam.accounts}
          onChange={onChange}
        />
      </div>
    </div>
  );
};

export default SearchParamUI;
